export default function(x) {
  return +x;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-scale/src/number.js
// module id = ./node_modules/d3-scale/src/number.js
// module chunks = 1